import moment from 'moment';
import 'moment/locale/ru';

/** «Октябрь 2026» из даты строки оценки (`2026-10-01`). */
export function formatRatingPeriod(dateAt?: string): string {
  if (!dateAt) return '';
  const month = moment(dateAt).locale('ru').format('MMMM YYYY');
  return month.charAt(0).toUpperCase() + month.slice(1);
}

export function formatDate(date?: string | null): string {
  return date ? moment(date).format('DD.MM.YYYY') : '';
}

/** Форма слова для числа: 1 оценка, 2 оценки, 5 оценок. */
export function pluralize(count: number, [one, few, many]: [string, string, string]): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');
}

/** Группирует элементы по ключу, сохраняя порядок первого появления. */
export function bucketBy<T>(items: T[], keyOf: (item: T) => string): Map<string, T[]> {
  const result = new Map<string, T[]>();
  items.forEach((item) => {
    const key = keyOf(item);
    result.set(key, [...(result.get(key) ?? []), item]);
  });
  return result;
}
